module.exports = __webpack_public_path__ + "img/img1.90a8768d.svg";